import { Box, CircularProgress, Divider } from "@mui/joy";
import { useNavigate, useParams } from "react-router-dom";

import { useRoles } from "../../../../hooks/query";
import { RoleDetails } from "./components/RoleDetails";
import { Breadcrumb } from "../Create/components";
import { Alert } from "../../../../shared";
import { useApiResponseParser } from "../../../../hooks";
import { IRole } from "../../../../interfaces";

export default function Edit() {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const { useList, useUpdate, useDelete } = useRoles();
    const { data: roles = [], isLoading, isError, error } = useList();
    const updateRoleSvc = useUpdate();
    const deleteRoleSvc = useDelete();
    const { parseErrorResponseData } = useApiResponseParser();

    const role = roles.find((r: IRole) => r.Id === id);

    async function handleUpdate(updatedData: IRole) {
        if (!id || !role) return;
        try {
            await updateRoleSvc.mutateAsync(updatedData);
        } catch (err) {
            console.error("Failed to update role:", err);
        }
    }

    async function handleDelete() {
        if (!id) return;
        try {
            await deleteRoleSvc.mutateAsync({ Id: id });
            navigate("/admin/roles");
        } catch (err) {
            console.error("Failed to delete role:", err);
        }
    }

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage={parseErrorResponseData(error)} />
            </Box>
        );
    }

    if (!role) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Role not found" />
            </Box>
        );
    }

    return (
        <Box
            flex={1}
            display={"flex"}
            flexDirection={"column"}
            maxHeight={"100%"}
            sx={{ overflow: "hidden", minWidth: 0 }}
        >
            <Breadcrumb />
            <Divider sx={{ position: "sticky", top: 48, zIndex: 10 }} />
            <Box
                component="div"
                width="100%"
                display="flex"
                flex={1}
                sx={{
                    overflow: "hidden",
                    minWidth: 0,
                }}
            >
                <Box
                    flex={1}
                    sx={{
                        overflow: "auto",
                        minWidth: 0,
                    }}
                >
                    <RoleDetails
                        role={role}
                        onUpdate={handleUpdate}
                        onDelete={handleDelete}
                        isUpdating={updateRoleSvc.isPending}
                        isDeleting={deleteRoleSvc.isPending}
                        updateError={updateRoleSvc.isError ? updateRoleSvc.error : undefined}
                    />
                </Box>
            </Box>
        </Box>
    );
}
